import { useSessionData } from './useSessionData';

export const useBooleanFeatureFlag = (flagName: string): boolean => {
	const sessionData = useSessionData();

	return Boolean(sessionData?.featureFlags?.[flagName]);
};
